<template>
  <el-dialog
    @open="iniciar"
    title="Gerar Boletos em Aberto"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="375px"
  >
    <el-form
      ref="form"
      size="small"
      label-position="top"
      hide-required-asterisk
      :show-message="false"
      style="padding:0;"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="">
            <el-select v-model="form.geracao" style="width:100%;">
              <el-option label="Gerar Pdf" value="PDF" />
              <el-option label="Enviar por e-mail" value="E_MAIL" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" >
        <el-col :span="24">
          <el-form-item prop="cliente" label="Cliente">
            <el-select v-model="cliente" value-key="id" style="width:100%;">
              <el-option
                v-for="item in clientesContrato"
                :key="item.id"
                :label="item.nome"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="form.geracao == 'E_MAIL'">
        <el-col :span="24">
          <el-form-item prop="email" label="E-mail">
            <el-input v-model="cliente.email" auto-complete="off" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="">
            <el-checkbox v-model="isGerarApenasRecibosComRemessaGerada">
              Gerar apenas boletos com remessa gerada
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button
        v-if="form.geracao == 'PDF'"
        @click="gerarBoleto"
        type="primary"
        size="small"
        round
        class="btn-box-shadow">
        Gerar
      </el-button>

      <el-button
        v-if="form.geracao == 'E_MAIL'"
        @click="enviarBoleto"
        type="primary"
        size="small"
        round
        class="btn-box-shadow">
        Enviar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    aluguel: Object,
    boletos: Array,
    visibility: Boolean,
  },

  data() {
    return {
      form: {
        geracao: "PDF",
        modelo: "BOLETO_COM_DEMONSTRATIVO",
      },

      cliente: {},

      isGerarApenasRecibosComRemessaGerada: false,
      validacao: {
        cliente: [{ required: true, validator: this.validarCliente }],
      }
    };
  },

  computed: {
    ...mapState('alugueisContratosStore', {
      clientesContrato(state) { return state.clientesContrato }
    }),
    idsBoletosComRemessaGerada() {
      return this.boletos
        .filter(boleto => boleto.sequencialRemessa && boleto.status == 'EM_ABERTO' && boleto.cliente.id == this.cliente.id)
        .map(boleto => boleto.id);
    },

    idsBoletosEmAberto() {
      return this.boletos
      .filter(boleto => boleto.status == 'EM_ABERTO' && boleto.cliente.id == this.cliente.id)
      .map(boleto => boleto.id);
    },

    naoExistemRecibosComRemessaGerada() {
      return this.idsBoletosComRemessaGerada.length === 0;
    },
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),
    ...mapActions('boletosAvulsosStore', [
      'gerarBoletosEmAberto',
      'enviarBoletosAvulsos',
    ]),
    ...mapActions('alugueisContratosStore', [
      'recuperarEnvolvidos'
    ]),
    async iniciar() {
      this.isGerarApenasRecibosComRemessaGerada = false;

      await this.handleRecuperarEnvolvidos();
    },

    async handleRecuperarEnvolvidos() {
      const payload = {
        aluguel: {
          id: this.aluguel.id,
        },
      };

      this.showLoading();
      try {
        await this.recuperarEnvolvidos(payload);
      } catch(e) {
        this.$message.error("Não foi possível recuperar os clientes");
        this.fechar();
      }
      this.hideLoading();
    },

    enviarBoleto() {
      if(!this.cliente.id) {
        this.$alert("Obrigatório selecionar um cliente", "Atenção", { confirmButtonOk: "Ok" })
        this.fechar();
        return;
      }

      if(!this.cliente.email || this.cliente.email == "") {
        this.$alert("Obrigatório informar um email para envio", "Atenção", { confirmButtonOk: "Ok" })
        this.fechar();
        return;
      }
        this.enviarBoletosEmAbertoHandler();
    },

    gerarBoleto() {
      if(!this.cliente.id) {
        this.$alert("Obrigatório selecionar um cliente", "Atenção", { confirmButtonOk: "Ok" })
        this.fechar();
        return;
      }
        this.gerarBoletosEmAbertoHandler();
    },

    gerarBoletosEmAbertoHandler() {
      if(this.isGerarApenasRecibosComRemessaGerada && this.naoExistemRecibosComRemessaGerada) {
        this.$message.warning('Não existem boletos com remessa gerada');
        return;
      }

      let idsBoletos = [];

      if(this.isGerarApenasRecibosComRemessaGerada) {
        idsBoletos = this.idsBoletosComRemessaGerada
      } else {
        idsBoletos = this.idsBoletosEmAberto
      }

      const payload = {
        aluguel: { id: this.aluguel.id },
        idsBoletos,
      };
      
      this.showLoading();
      this.gerarBoletosEmAberto(payload)
        .then(resultado => {
          switch(resultado.status) {
            case "SUCESSO": {
              const url = resultado.item;
              window.open(url, "_blank");
              break;
            }
            case "FALHA":
              this.$message.warning(resultado.mensagem);
              break;
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
          this.cliente = {}
          this.$emit('close');
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    enviarBoletosEmAbertoHandler() {
      if(this.isGerarApenasRecibosComRemessaGerada && this.naoExistemRecibosComRemessaGerada) {
        this.$message.warning('Não existem boletos com remessa gerada');
        return;
      }

      let idsBoletos = [];

      if(this.isGerarApenasRecibosComRemessaGerada) {
        idsBoletos = this.idsBoletosComRemessaGerada
      } else {
        idsBoletos = this.idsBoletosEmAberto
      }

      idsBoletos.reverse();

      const payload = {
        aluguel: { id: this.aluguel.id },
        idsBoletos,
        cliente: this.cliente
      };

      this.showLoading();

      this.enviarBoletosAvulsos(payload)
        .then(resultado => {
          switch(resultado.status) {
            case "SUCESSO": {
              this.$message.success(resultado.mensagem);
              break;
            }
            case "FALHA":
              this.$message.warning(resultado.mensagem);
              break;
          }
          this.$emit('close');
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    fechar() {
      this.$emit('close');
      this.cliente = {}
    }, 
  },
};
</script>
